import styled, { css } from 'styled-components'
import { Alert as DfhAlert } from '@designsforhealth/dfh-react-components'

export const OuterContainer = styled.div<{ $dragActive: boolean }>`
  width: 100%;
  margin-bottom: 24px;
  ${({ $dragActive }) =>
    // disable pointer events on children while drag active
    $dragActive &&
    css`
      * {
        pointer-events: none;
      }
    `};
`

export const HiddenInput = styled.input`
  display: none;
`

export const InnerContainer = styled.div<{
  $dragActive: boolean
  $fileSubmitted?: boolean
  $fileSizeError?: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 8px;
  border: 1px dashed
    ${({ theme, $fileSizeError }) => ($fileSizeError ? theme.colors.semantic.error : '#5f77a7')};
  height: 80px;
  pointer-events: auto;
  cursor: pointer;
  ${({ $dragActive }) =>
    $dragActive &&
    css`
      background-color: ${({ theme }) => theme.colors.coolGray.cool150};
    `};
  ${({ $fileSubmitted }) =>
    $fileSubmitted &&
    css`
      pointer-events: none;
      border: 1px solid #71727a;
    `};
`

export const Actions = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const DragText = styled.div<{ $fileSubmitted: boolean; $fileSizeError?: boolean }>`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  color: ${({ theme, $fileSizeError }) =>
    $fileSizeError ? theme.colors.semantic.error : '#5f77a7'};
  font-size: 16px;
  line-height: 1.25;
  ${({ $fileSubmitted }) =>
    $fileSubmitted &&
    css`
      color: ${({ theme }) => theme.colors.grayscale.black};
    `};
`

export const FileSizeText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
`

export const FileAttachIcon = styled.img<{ $fileSizeError?: boolean }>`
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 5px;
  ${({ $fileSizeError }) =>
    $fileSizeError ? 'filter: hue-rotate(137deg) saturate(39.39) brightness(92.35%);' : ''}
`

export const CloseIcon = styled.img`
  display: block;
  width: 16px;
  height: 16px;
`

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.06em;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  color: ${({ theme }) => theme.colors.grayscale.black};
  text-transform: uppercase;
  margin-bottom: 20px;
`

export const TitleHelper = styled.div`
  font-size: 15px;
  line-height: 30px;
  display: block;
  font-weight: 300;
  text-transform: none;
  letter-spacing: 0;
`

export const Alert = styled(DfhAlert)`
  margin-top: -10px;
`

export const RemoveFileButton = styled.button`
  position: absolute;
  right: 24px;
  top: 0;
  bottom: 0;
  border: 0;
  padding: 0;
  background-color: transparent;
  pointer-events: auto;
  cursor: pointer;
`
